// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__115Px","recovery":"styles_recovery__3QLEw","form":"styles_form__1-NGy","actions":"styles_actions__3_UcI"};